import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsumerDashboardComponent } from '../dashboard/dashboard.component';

@Component({
  selector: 'app-consumer-home',
  standalone: true,
  imports: [CommonModule, ConsumerDashboardComponent],
  templateUrl: './home.component.html',
})
export class ConsumerHomeComponent {
  // Home component acts as an entry point that renders the dashboard component
  // The dashboard component handles its own access control and role checking
}
